import * as React from "react";
import { EmailForm } from "~/modules/auth/components/EmailForm";
import { AuthFormCardSeparator } from "~/modules/auth/components/AuthFormCard";
import { OAuthButton } from "~/modules/auth/components/OAuthButton";
import { OTPVerification } from "~/modules/auth/components/OTPVerification";

// // // //

/**
 * InlineAuthForm
 * Compact email / Google / OTP sign-in form for embedding in drawers and cards.
 */
export function InlineAuthForm(props: {
    variant?: "login" | "register";
    currentStep: "auth" | "otp";
    isLoading: boolean;
    userEmail: string;
    errorMessage: string | null;
    onGoogleSignIn: () => void;
    onEmailSubmit: (email: string) => void;
    onOTPSubmit: (code: string, email: string) => void;
}) {
    const {
        variant = "register",
        currentStep,
        isLoading,
        userEmail,
        errorMessage,
        onGoogleSignIn,
        onEmailSubmit,
        onOTPSubmit,
    } = props;

    if (currentStep === "auth") {
        return (
            <div className="w-full max-w-md mx-auto min-h-[280px]">
                {/* <AuthCardHeader
                    title="Sign in to your RWA.xyz account"
                    description={
                        <>
                            Thank you for exploring RWA.xyz. Please create a
                            free account to continue exploring real-world asset
                            tokenization.
                        </>
                    }
                /> */}

                <div className="mt-5 sm:mt-8 space-y-4 sm:space-y-6">
                    <EmailForm
                        disabled={isLoading}
                        onSubmit={onEmailSubmit}
                        showLoading={isLoading}
                        isWorkEmailOnly={true}
                        variant={variant}
                    />

                    {errorMessage && (
                        <p
                            role="alert"
                            className="text-center text-sm leading-relaxed text-red-600"
                        >
                            {errorMessage}
                        </p>
                    )}

                    <AuthFormCardSeparator />

                    <OAuthButton
                        provider="google"
                        variant="login"
                        disabled={isLoading}
                        loading={false}
                        onClick={onGoogleSignIn}
                    />
                </div>
            </div>
        );
    }

    if (currentStep === "otp") {
        return (
            <div className="w-full max-w-md mx-auto min-h-[280px]">
                <div className="text-center mb-6">
                    <h2 className="text-center text-xl font-normal tracking-tight text-slate-800 sm:text-[1.375rem]">
                        Check your email
                    </h2>
                    {errorMessage ? (
                        <p className="mt-2 text-center text-sm leading-relaxed text-red-600">
                            {errorMessage}
                        </p>
                    ) : (
                        <p className="mt-2 text-center text-sm leading-relaxed text-secondary-foreground">
                            A sign-in code has been sent to your email address.
                        </p>
                    )}
                </div>

                <OTPVerification
                    email={userEmail}
                    isLoading={isLoading}
                    onSubmit={onOTPSubmit}
                />
            </div>
        );
    }

    return null;
}
